import React, { useState } from 'react';
import { Check, Copy } from 'lucide-react';
import { serverIp } from '../config/site.js';

export default function CopyButton({ compact = false, copiedText = 'Copied' }) {
  const [copied, setCopied] = useState(false);

  async function copyAddress() {
    try {
      await navigator.clipboard.writeText(serverIp);
      setCopied(true);
      window.setTimeout(() => setCopied(false), 1400);
    } catch {
      setCopied(false);
    }
  }

  return (
    <button className={compact ? 'copy-btn compact' : 'copy-btn'} type="button" onClick={copyAddress}>
      {copied ? <Check size={18} /> : <Copy size={18} />}
      <span>{copied ? copiedText : serverIp}</span>
    </button>
  );
}
